<app-form-field-render [field]="self" [suffix]="iconSuffixTmpl">
  <input
    readonly
    type="text"
    class="form-control"
    [formControl]="ctrl"
    [class.is-invalid]="isTouchedInvalid"
    [placeholder]="placeholder || ''"
    (focus)="datePicker.open()"
    (click)="datePicker.open()"
    [matDatepicker]="datePicker"
    [min]="minDate"
    [max]="maxDate"
  />
</app-form-field-render>
<mat-datepicker #datePicker (opened)="onOpen()" (closed)="onClose()"></mat-datepicker>

<ng-template #iconSuffixTmpl>
  <form-field-affix (click)="datePicker.open()">
    <i class="far fa-calendar-day"></i>
  </form-field-affix>
</ng-template>
